import React, { useContext, useEffect, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Auth, Storage } from 'aws-amplify';
import Cookies from 'universal-cookie';

import { Dialog } from 'primereact/dialog';
import { confirmDialog } from 'primereact/confirmdialog';

import { FILEUPLOAD_S3, FILEUPLOAD_S3_LEVEL, SetS3Config } from 'config/amplify_config';

import { UserDetailsContext } from 'context/userDetailsContext';
import { WebSocketConnectionContext } from 'context/WebSocketConnectionContext';

import { generateFullName } from 'utils/generateFullNameUtils';
import { getTenantIdFromLS, getUserInfoFromLS } from 'utils/localStorageUtils';
import { useSecureMessageContext } from '../Context/SecureMessageContext';
import MessageCreateForm from './MessageCreateForm';
import { getClientUserList } from 'services/users/userServices';
import { listEvents } from 'services/Calender/calendarServices';
import { uuidv4 } from 'common/uuidGenerator';
import { sortByKey } from 'utils/utils';
import { getTimezoneOffset } from 'utils/utility_functions/timezone';
import { getAutoSave } from 'services/messageServices';
import { validateUpload } from 'services/fileManager/fileManagerServices';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
const cookie = new Cookies();
let setMsgInterval = null;

function MessageCreateModal({ show, setShow, companionLink, companionList, createInAllCompanions }) {
  const {
    handleSubmit,
    control,
    resetField,
    setError,
    setValue,
    watch,
    getValues,
    formState: { errors, isDirty, isSubmitting },
    reset,
  } = useForm();

  const {
    fetchCaseMessage,
    isLeadSpecific,
    isFromCaseSpecificModule,
    isGlobalMessagesScreen,
    caseDetails,
    isFromClientPortal,
    clientPortalDashboard,
    clientDashboardSelectedCase,
    onMountUnMount,
    onOperationBreak,
    loadFirmUserList,
    firmUserList,
    messageScheduleData,
    setMessageScheduleData,
  } = useSecureMessageContext();

  let { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(useLocation().search);

  const userContext = useContext(UserDetailsContext);
  const websocketContext = useContext(WebSocketConnectionContext);
  const { addToast } = useToast();

  const [attendeesList, setAttendeesList] = useState([]);
  const [eventAndTaskAllData, setEventAndTaskAllData] = useState({
    events: [],
    tasks: [],
  });
  const [eventData, setEventData] = useState({ events: [], tasks: [] });
  const [files, setFiles] = useState([]);
  const [hasAutoSaveData, setHasAutoSaveData] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [scheduleData, setScheduleData] = useState();

  const { case_id } = caseDetails || {};

  const qlEditor = document?.querySelector('.ql-editor');
  const qlHeader = document?.querySelector('.ql-header');

  if (qlHeader) {
    qlHeader.onkeyup = function (e) {
      if (e.key === 'Tab') {
        if (qlEditor) {
          qlEditor.focus();
        }
      }
    };
  }

  // Set initial companion_link value immediately when modal opens
  useEffect(() => {
    if (companionLink !== undefined) {
      setValue('companion_link', companionLink);
    }
  }, [companionLink, setValue]);

  useEffect(() => {
    getAutoSave(case_id).then((res) => {
      if (isGlobalMessagesScreen) {
        res?.data?.caseId?.id && loadCaseContacts(res?.data?.caseId?.id);
      }

      if (Object.keys(res?.data).length) {
        // Preserve the initial companionLink value when resetting with autosave data
        const currentValues = getValues();
        const preservedCompanionLink = companionLink !== undefined ? companionLink : currentValues.companion_link;

        reset(
          {
            ...currentValues,
            ...res?.data,
            // Always preserve the initial companion_link value
            companion_link: preservedCompanionLink,
          },
          {
            keepDirty: false,
          }
        );
        if (res?.data?.schedule_data) {
          setScheduleData(res.data.schedule_data);
        }
        setHasAutoSaveData(true);
      }
    });
    if (case_id) {
      setValue('caseId', case_id);
      getCaseClients(case_id);
    }
    if (clientPortalDashboard) {
      setValue('caseId', { id: clientDashboardSelectedCase.case_id, case_name: clientDashboardSelectedCase.case_name });
      getCaseClients(clientDashboardSelectedCase.case_id);
    }
    //automated time entry logic
    !isFromClientPortal && typeof onMountUnMount === 'function' && onMountUnMount('create-message', 'mounted');
    return () => {
      !isFromClientPortal && typeof onOperationBreak === 'function' && onOperationBreak();
    };
  }, []);

  useEffect(() => {
    setMsgInterval = setInterval(() => {
      if (isDirty || scheduleData) {
        const dataToSave = {
          ...getValues(),
          schedule_data: scheduleData,
        };
        sendAutoSaveReq(dataToSave);
      }
    }, 5000);
    return () => {
      clearInterval(setMsgInterval);
    };
  }, [isDirty, scheduleData]);

  useEffect(() => {
    loadFirmUserList();
  }, []);

  const getCaseClients = (case_id) => {
    resetField('messageTo');
    resetField('event_attachment');
    resetField('task_attachment');
    resetField('existing_files');
    if (case_id) {
      loadCaseContacts(case_id);
      !isFromClientPortal && getEventData(case_id);
    } else {
      loadCaseContacts();
      !isFromClientPortal && getEventData();
    }
  };

  // get event and task data
  const getEventData = (id = '') => {
    let obj = {
      data: { firm_user: [] },
      case_id: id,
      date_filter_param: 'upcoming',
      user_timezone: getTimezoneOffset(userContext?.userDetails?.timezone),
    };
    listEvents(obj)
      .then((res) => {
        let events = [];
        let tasks = [];

        if (res?.data?.events?.length) {
          events = res.data.events.map((val) => {
            return {
              label: val.title,
              value: val.sk,
            };
          });
        }

        if (res?.data?.tasks?.length) {
          tasks = res.data.tasks.map((val) => {
            return {
              label: val.task_name,
              value: val.sk,
            };
          });
        }
        setEventAndTaskAllData({
          events: res.data.events,
          tasks: res.data.tasks,
        });
        setEventData({ events: events, tasks: tasks });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // get case specific contacts
  const loadCaseContacts = (id_case = '') => {
    let obj = {
      caseId: id_case,
      all_contacts: clientPortalDashboard ? null : true,
      contact_id: isGlobalMessagesScreen || clientPortalDashboard ? userContext?.userDetails?.contact_id : false,
      is_team_member_list: clientPortalDashboard ? null : true,
      is_include_groups: true,
      active_groups: true,
      excludeFromLoading: false,
    };

    getClientUserList(obj)
      .then((response) => {
        if (response && response.data && response.data.length) {
          let users = [];
          let firmUsers = [];
          let groups = [];
          response.data.forEach((element) => {
            if (element?.res_type === 'user-group') {
              groups.push({
                label: element.group_name,
                value: element.user_group_id,
                ...element,
              });
            } else {
              function generateLabel(element) {
                if (element.contact_type === 'person' || element.first_name || element.middle_name || element.last_name) {
                  return generateFullName(element);
                }
                return element.title;
              }

              const label = generateLabel(element);

              const userData = {
                label: label,
                value: element.client_cognito_username ? element.client_cognito_username : element.contact_id,
                email: element.email,
                is_create_client_portal: element.is_create_client_portal,
                access_level: element.access_level,
                ...element,
              };
              if (element?.contact_type) {
                users.push(userData);
              } else {
                firmUsers.push(userData);
              }
            }
          });
          let grouped_data = [];
          if (groups.length > 0) {
            grouped_data.push({
              label: 'Groups',
              items: groups.sort((a, b) => (a.group_name?.toLowerCase() || '').localeCompare(b.group_name?.toLowerCase() || '')),
            });
          }
          if (firmUsers?.length > 0) {
            grouped_data.push({
              label: 'Firm Users',
              items: sortByKey(firmUsers, 'first_name').filter((user) => user.firm_user_id !== userContext?.userDetails?.firm_user_id),
            });
          }
          if (users.length > 0) {
            const clients = users?.filter((user) => user.access_level === 'client' && user?.res_type === 'case_contact');
            const primaryContacts = users?.filter((user) => user.is_primary_contact);
            const billingContacts = users?.filter((user) => user.is_billing_contact);
            const otherUsers = users?.filter(
              (user) => !user.is_billing_contact && !user.is_primary_contact && user?.res_type !== 'case_contact'
            );

            const sortedClients = sortByKey(clients, 'first_name');
            const sortedPrimaryContacts = sortByKey(primaryContacts, 'first_name');
            const sortedBillingContacts = sortByKey(billingContacts, 'first_name');
            const sortedOtherUsers = sortByKey(otherUsers, 'first_name');

            const sortedUsers = [...sortedClients, ...sortedPrimaryContacts, ...sortedBillingContacts, ...sortedOtherUsers];
            const uniqueSortedUsers = Array.from(new Map(sortedUsers.map((user) => [user.contact_id, user])).values());

            // Re-sort the final combined list to maintain alphabetical order
            const finalSortedUsers = sortByKey(uniqueSortedUsers, 'first_name');

            grouped_data.push({
              label: 'Contacts',
              items: finalSortedUsers,
            });
          }
          grouped_data.reverse();
          setAttendeesList(grouped_data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  async function fileUpload(caseIdVal) {
    let attachments = [];
    if (files && files.length > 0) {
      const filesData = Object.values(files);
      const totalSize = filesData.reduce((acc, f) => acc + f.size, 0);

      let totalUploaded = 0; // Track uploaded bytes cumulatively

      try {
        await validateUpload(totalSize);
      } catch (err) {
        console.error('Validation failed:', err);
        let errorMsg = err?.response?.data?.message || err?.response?.data || err?.message || 'File validation failed';

        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, errorMsg);
        return null;
      }

      try {
        const tenantId = (await cookie.get('tenantId')) || '';
        const moduleName = 'messages';
        const userId = userContext?.userDetails?.firm_user_id;

        let case_Id;
        if (isGlobalMessagesScreen && caseIdVal) {
          case_Id = caseIdVal;
        } else {
          case_Id = case_id;
        }

        // Use an object to track per-file uploaded bytes, so later progress don't overlap
        let perFileUploaded = filesData.map(() => 0);

        for (let i = 0; i < filesData.length; i++) {
          const element = filesData[i];
          SetS3Config(FILEUPLOAD_S3, FILEUPLOAD_S3_LEVEL);
          let user = await Auth.currentAuthenticatedUser();

          let response = await Storage.put(
            `${moduleName}/${tenantId}/${userId}/${case_Id ? case_Id + '/' : ''}${uuidv4()}#$#${encodeURIComponent(element.name)}`,
            element,
            {
              contentType: element.type,
              progressCallback: (progress) => {
                const { loaded } = progress;

                // Calculate incremental uploaded bytes for this file
                let delta = loaded - perFileUploaded[i];

                if (delta > 0) {
                  // Update per file uploaded bytes
                  perFileUploaded[i] = loaded;

                  // Update total uploaded bytes
                  totalUploaded += delta;

                  // Calculate overall upload percentage
                  let percent = Math.floor((totalUploaded / totalSize) * 100);
                  // Clamp percent to max 100
                  percent = percent > 100 ? 100 : percent;

                  // Update UI progress (uncomment your setUploadPercentage or similar)
                  setUploadPercentage(percent);
                }
              },
              useAccelerateEndpoint: true,
            }
          );

          if (response.key) {
            let file_type = element.type.toString();
            let file_details = {
              file_name: element.name,
              display_name: element.name,
              size: element.size.toString(),
              file_path: 'public/' + response.key,
              file_type: file_type,
              created_by: user.attributes,
            };
            attachments.push(file_details);
          }
        }
        setUploadPercentage(100); // ensure 100% at end
        return attachments;
      } catch (err) {
        console.log(err);
        return attachments;
      }
    } else {
      return attachments;
    }
  }

  const handleClose = () => {
    // Blur any focused element to prevent focus trap issues
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
    setShow(false);
    params.delete('createMessage');

    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  const createMessage = (data) => {
    if (setMsgInterval) {
      clearInterval(setMsgInterval);
    }

    const usersArray = attendeesList
      ?.filter((item) => item.label === 'Contacts' || item.label === 'Firm Users')
      ?.flatMap((item) => item.items);

    const assign_to = data.messageTo.flatMap((val) => {
      const fullData = usersArray?.find((value) => {
        const optionValue = value.client_cognito_username || value.contact_id;
        return optionValue === val;
      });

      if (!fullData) {
        return [];
      }

      const recipient_id = fullData.client_cognito_username ?? fullData.contact_id;

      return [
        {
          recipient_name: generateFullName(fullData),
          recipient_id: recipient_id,
          client_cognito_username: fullData.client_cognito_username,
          firm_user_id: fullData.firm_user_id ?? '',
          contact_id: fullData.contact_id ?? '',
          email: fullData.email,
          access_level: fullData.access_level,
          role: fullData.role,
        },
      ];
    });

    const groupsArray = attendeesList?.find((item) => item.label === 'Groups')?.items;

    const groups = data.messageTo.flatMap((val) => {
      const fullGroupData = groupsArray?.find((group) => {
        return group.user_group_id === val;
      });

      if (!fullGroupData) {
        return [];
      }

      const obj = {
        group_name: fullGroupData.group_name,
        group_id: fullGroupData.user_group_id,
        sk: fullGroupData.sk,
      };

      return [obj];
    });

    // tasks data
    let finalTask = [];
    if (data?.task_attachment?.length) {
      finalTask = data.task_attachment.map((task) => {
        let val = eventAndTaskAllData.tasks.find((value) => value.sk === task);
        if (val) {
          return {
            assign_to: assign_to,
            ...val,
          };
        }
      });
    }

    // events data
    let finalEvents = [];
    if (data?.event_attachment?.length) {
      finalEvents = data.event_attachment.map((event) => {
        let val = eventAndTaskAllData.events.find((value) => value.sk === event);
        if (val) {
          return {
            event_name: val.title,
            ...val,
          };
        }
      });
    }

    let sendData = {
      is_global_module: isGlobalMessagesScreen || clientPortalDashboard,
    };

    const tenantId = getTenantIdFromLS();

    if (assign_to?.length > 0) {
      sendData.recipients = assign_to?.map((index) => index.recipient_id);
    }

    sendData.action = 'message';
    sendData.type = 'secure_message';
    sendData.data = {};
    sendData.data.secure_message_type = 'thread';
    sendData.data.tenant_id = tenantId;
    sendData.data.body = {};
    sendData.data.body.message_to = assign_to;
    sendData.data.body.groups = groups;
    sendData.data.body.subject = data.subject;
    sendData.data.body.message = data.message;
    sendData.data.body.attachment = data.attachments;

    sendData.data.body.event_attachment = finalEvents;
    sendData.data.body.task_attachment = finalTask;

    sendData.data.body.assign_to = data.assign_to ?? [];
    sendData.data.body.resolution_status = data.resolution_status ? data.resolution_status : false;
    // Add companion case logic
    sendData.data.body.companion_link = data?.companion_link && companionList?.length > 0 ? true : false;
    sendData.data.body.create_in_all_companions = createInAllCompanions && companionList?.length > 0 ? true : false;
    sendData.data.body.scheduled_send_at = scheduleData?.datetime;

    if (isGlobalMessagesScreen || clientPortalDashboard) {
      sendData.case_id = data?.caseId?.id;
      sendData.data.body.case_id = data.caseId?.id;
      sendData.data.body.case_name = data.caseName;
    } else {
      let idKey = isLeadSpecific ? case_id : id;
      sendData.case_id = idKey;
      sendData.data.body.case_id = idKey;
      sendData.data.body.is_lead = !!isLeadSpecific;
      if (caseDetails?.case_description?.case_name) {
        sendData.data.body.case_name = caseDetails.case_description.case_name;
      }
    }

    let userInfo = getUserInfoFromLS();

    if (userInfo?.attributes) {
      sendData.creator_first_name = userInfo.attributes['custom:first_name'];
      sendData.creator_last_name = userInfo.attributes['custom:last_name'];
      sendData.creator_email = userInfo.attributes['email'];
    }

    if (clientPortalDashboard) {
      sendData.contact_id = userContext?.userDetails?.contact_id;
    }

    if (scheduleData) {
      setMessageScheduleData(scheduleData);
    }

    websocketContext
      .sendMessage(sendData)
      .then(() => {
        !isFromClientPortal &&
          typeof onMountUnMount === 'function' &&
          onMountUnMount('create-message', 'unmounted', sendData?.data?.body?.case_id);
        !clientPortalDashboard && fetchCaseMessage({});
        if (scheduleData) {
          setScheduleData(null);
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, 'Message scheduled successfully');
        } else {
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, 'Message sent successfully');
        }
        handleClose();
      })
      .catch((err) => {
        !isFromClientPortal && typeof onOperationBreak === 'function' && onOperationBreak();
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, err?.message || 'Failed to send message');
      });
  };

  const sendAutoSaveReq = async (sendData, is_delete = false) => {
    const reqData = {
      user_id: userContext.firmDetails.current_user,
      tenant_id: userContext.firmDetails.tenant_id,
      auto_save_type: 'thread',
      action: 'autosave',
      type: 'autosave_message',
      is_delete,
      case_id: case_id || id,
    };
    userContext.firmDetails.firm_user_id && (reqData.firm_user_id = userContext.firmDetails.firm_user_id);
    userContext.firmDetails.contact_id && (reqData.contact_id = userContext.firmDetails.contact_id);
    reqData.data = sendData;
    await websocketContext.sendMessage(reqData);
  };

  // submit create message form
  const onSubmit = async (data) => {
    if (isLeadSpecific || isFromCaseSpecificModule) {
      data.caseName = caseDetails?.case_description?.case_name ? caseDetails.case_description.case_name : 'TBD';
    } else {
      data.caseName = data?.caseId?.case_name;
    }
    if (files?.length > 0) setUploadPercentage(1); // to show the progress immediately
    const uploadedAttachments = await fileUpload(data?.caseId?.id);
    if (uploadedAttachments === null) return;
    data.attachments = uploadedAttachments;
    if (data.existing_files && data.existing_files.length > 0) {
      data.attachments = [...data.attachments, ...data.existing_files];
    }
    createMessage(data);
  };

  const headerComponent = (data) => {
    return (
      <div>
        <i
          className="icon-window-filled modal-close-icon F-size14 pointer"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (data?.onHide) {
              data.onHide();
            }
          }}
        ></i>
      </div>
    );
  };

  const clearUnsavedData = () => {
    if (isDirty || hasAutoSaveData || scheduleData) {
      confirmDialog({
        message: 'Do you want to draft save this message?',
        header: 'Discard',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          const dataToSave = {
            ...getValues(),
            schedule_data: scheduleData,
          };

          sendAutoSaveReq(dataToSave)
            .then(() => {
              handleClose();
            })
            .catch((err) => {
              console.error(err);
              handleClose();
            });
        },
        reject: () => {
          handleClose();
          //To clear the unsaved data
          sendAutoSaveReq(null, true);
        },
      });
    } else {
      handleClose();
    }
  };

  return (
    <Dialog header={headerComponent} visible={show} onHide={clearUnsavedData} className="create-msg-popup" closable={false} modal={true}>
      <MessageCreateForm
        onSubmit={onSubmit}
        handleSubmit={handleSubmit}
        errors={errors}
        resetField={resetField}
        control={control}
        setError={setError}
        watch={watch}
        attendeesList={attendeesList}
        eventData={eventData}
        setFiles={setFiles}
        files={files}
        clientPortalDashboard={clientPortalDashboard}
        getCaseClients={getCaseClients}
        handleClose={clearUnsavedData}
        isSubmitting={isSubmitting}
        uploadPercentage={uploadPercentage}
        setValue={setValue}
        firmUserList={firmUserList}
        companionLink={companionLink}
        companionList={companionList}
        createInAllCompanions={createInAllCompanions}
        scheduleData={scheduleData}
        setScheduleData={setScheduleData}
        isFromClientPortal={isFromClientPortal}
      />
    </Dialog>
  );
}

export default MessageCreateModal;
